export const LoyaltySvg = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="23" height="16" viewBox="0 0 23 16" fill="none">
			<path
				d="M3.29123 2.93489C3.54445 2.40282 4.19889 2.16861 4.75296 2.41178L12.3212 5.73326C12.8752 5.97642 13.1191 6.60489 12.8659 7.13697L9.67475 13.8424C9.42153 14.3745 8.76709 14.6087 8.21301 14.3655L0.644817 11.044C0.0907431 10.8009 -0.153146 10.1724 0.100074 9.64031L3.29123 2.93489Z"
				fill="url(#paint0_linear_26814_10364)"
			/>
			<path
				d="M9.20105 0.320388C9.62599 -0.0988026 10.3243 -0.107819 10.7608 0.300248L16.5017 5.66688C16.9382 6.07495 16.9476 6.74557 16.5226 7.16476L9.45846 14.1334C9.03352 14.5526 8.33518 14.5616 7.89866 14.1536L2.15785 8.78695C1.72133 8.37888 1.71194 7.70825 2.13688 7.28906L9.20105 0.320388Z"
				fill="url(#paint1_linear_26814_10364)"
			/>
			<path
				d="M16.3532 1.08256C16.9 0.824706 17.561 1.04136 17.8295 1.56648L20.9221 7.61453C21.1906 8.13965 20.965 8.77438 20.4182 9.03223L9.16452 14.3389C8.6177 14.5968 7.95674 14.3801 7.68822 13.855L4.5956 7.80693C4.32708 7.28182 4.5527 6.64709 5.09953 6.38923L16.3532 1.08256Z"
				fill="url(#paint2_linear_26814_10364)"
			/>
			<path
				d="M13.193 2.57605L16.5028 5.67021C16.9394 6.07828 16.9488 6.7489 16.5238 7.16809L9.45965 14.1368C9.38674 14.2087 9.30579 14.2685 9.21949 14.3163L9.16452 14.3422C8.6177 14.6 7.95673 14.3834 7.68822 13.8583L4.5956 7.81022C4.32708 7.2851 4.5527 6.65037 5.09953 6.39252L13.193 2.57605Z"
				fill="url(#paint3_linear_26814_10364)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_26814_10364"
					x1="7.50983"
					y1="13.8926"
					x2="4.16008"
					y2="2.67269"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#FFD540" />
					<stop offset="1" stopColor="#FFA800" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_26814_10364"
					x1="9.67491"
					y1="0.154216"
					x2="10.0291"
					y2="14.183"
					gradientUnits="userSpaceOnUse">
					<stop offset="0.0001" stopColor="#C0E671" />
					<stop offset="1" stopColor="#5CA500" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_26814_10364"
					x1="17.0156"
					y1="2.0149"
					x2="15.5869"
					y2="14.4406"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#75CFF4" />
					<stop offset="1" stopColor="#0094C2" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_26814_10364"
					x1="15.5501"
					y1="3.33547"
					x2="10.9862"
					y2="14.5835"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#289DC6" stopOpacity="0.29" />
					<stop offset="1" stopColor="#289DC6" stopOpacity="0" />
				</linearGradient>
			</defs>
		</svg>
	)
}
